import { removeAccessToken } from '../utils/utilities';
import httpService from './httpService';

const geocodeBaseUrl: string = process.env.REACT_APP_TOMTOM_BASE_URL as string;
const geocodeApiKey: string = process.env.REACT_APP_TOMTOM_API_KEY as string;

const getPlaces = (address: string) => {
	const endpoint: string = `${geocodeBaseUrl}/search/2/search/${address}.json?key=${geocodeApiKey}`;
	return httpService.get(endpoint, removeAccessToken());
};

export { getPlaces };
